import 'twin.macro';
import React from 'react';
import PrismicText from '@leuven2030/framework/Prismic/PrismicText';

const ContentList = ({ data: { indentation }, fields }) => {
  console.log(indentation);
  return (
    <div tw="space-y-0 sm:space-y-3" css={{ marginLeft: 0 }}>
      {fields.map(({ text }, index) => {
        return (
          <div tw="flex items-center space-x-3" key={index}>
            <div
              tw="min-w-max w-8 min-h-full h-8 flex justify-center items-center bg-primary-500 text-white rounded-full"
              style={{ minWidth: 'rem', minHeight: '2rem' }}
            >
              {index + 1}
            </div>
            <PrismicText text={text} />
          </div>
        );
      })}
    </div>
  );
};

ContentList.type = 'list';

export default ContentList;
